

import ReactECharts from 'echarts-for-react';

const FaparChart = ({ data, compact = false, chartTitle }) => {
  data = data.sort((a, b) => new Date(a.date) - new Date(b.date))
  var barWidth = compact ? 8 : 14;
  const getOption = () => {
    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        data: ['Extremely low', 'Severely low', 'Moderately low', 'Near Normal Conditions', 'Moderately high', 'Very high', 'Extremely high'],
        ...(compact
          ? { type: 'scroll', textStyle: { fontSize: 10 }, itemWidth: 12, itemHeight: 10, itemGap: 6 }
          : { align: 'left' }),
        bottom: 0
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: compact ? '18%' : '10%',
        containLabel: true,
        show: false
      },
      xAxis: {
        type: 'category',
        data: data.map(item => item.date),
        axisTick: {
          alignWithLabel: true
        },
        axisLine: {
          show: true
        },
        axisLabel: {
          show: true
        }
      },
      yAxis: {
        type: 'value',
        name: '% Whole Region',
        nameLocation: 'middle',
        nameGap: 25,
        nameTextStyle: {
          padding: [0, 0, 20, 0]
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: true
        },
        splitLine: {
          show: true
        }
      },
      toolbox: {
        show: true,
        feature: {
          saveAsImage: {
            show: true,
            title: 'Download',
            name: chartTitle || 'FAPAR Chart',
            pixelRatio: 2
          }
        },
        right: 20
      },
      series: [
        {
          name: 'Extremely low',
          type: 'bar',
          stack: 'total',
          barWidth: barWidth, // Adjust the bar width as needed
          data: data.map(item => item['Extremely low']),
          itemStyle: {
            color: '#D73062'
          }
        },
        {
          name: 'Severely low',
          type: 'bar',
          stack: 'total',
          barWidth: barWidth,
          data: data.map(item => item['Severely low']),
          itemStyle: {
            color: '#FC8D95'
          }

          
        },
       
        {
          name: 'Moderately low',
          type: 'bar',
          stack: 'total',
          barWidth: barWidth,
          data: data.map(item => item['Moderately low']),
          itemStyle: {
            color: '#FEE0C7'
          },
        },

        {
          name: 'Near Normal Conditions',
          type: 'bar',
          stack: 'total',
          barWidth: barWidth,
          data: data.map(item => item['Near Normal Conditions']),
          itemStyle: {
            color: '#CCCCCC'
          },
        },

        {
          name: 'Moderately high',
          type: 'bar',
          stack: 'total',
          barWidth: barWidth,
          data: data.map(item => item['Moderately high']),
          itemStyle: {
            color: '#AFEE51'
          },
        },
        {
          name: 'Very high',
          type: 'bar',
          stack: 'total',
          barWidth: barWidth,
          data: data.map(item => item['Very high']),
          itemStyle: {
            color: '#4CA602'
          },
        },

        {
          name: 'Extremely wet',
          type: 'bar',
          stack: 'total',
          barWidth: barWidth,
          data: data.map(item => item['Extremely high']),
          itemStyle: {
            color: '#126E00'
          },
        },
      ],
      barCategoryGap: '0%' ,// Adjust the category gap as needed (default is 20%)
      barGap: '-100%',
    };
  };

  return <ReactECharts option={getOption()} style={{ height: compact ? '240px' : '300px', width: '100%' }} />;
};


export default FaparChart;
